
declare const window: any;
declare const hermes: any;

export class Logger {
  public static readonly APP_NAME = 'StarsCRM Content Loader';

  public static report(e: any): void {
    if (this.hasHermes()) {
      hermes('report', e);
    }
  }

  public static error(e: string): void {
    if (Logger.hasHermes()) {
      hermes('error', e);
    }
  }

  public static warn(e: string): void {
    if (Logger.hasHermes()) {
      hermes('warn', e);
    }
  }

  public static log(e: string): void {
    if (Logger.hasHermes()) {
      hermes('log', e);
    }
  }

  public static debug(e: string): void {
    if (Logger.hasHermes()) {
      hermes('debug', e);
    }
  }

  public static info(e: string): void {
    if (Logger.hasHermes()) {
      hermes('info', e);
    }
  }

  public static fatal(e: string): void {
    if (Logger.hasHermes()) {
      hermes('fatal', e);
    }
  }

  private static hasHermes() {
    return window && window.hermes;
  }
}



// WEBPACK FOOTER //
// ./src/logger.ts